import { withBusyButton } from '../../../core/ui/withBusyButton.js';
import { createPublicarView } from './publicarPresenter.js';
import { createMisPublicacionesView } from './misPublicacionesPresenter.js';
import { escapeHtml as esc } from '../../../core/ui/escapeHtml.js';
import { iconArrowRight, bloqueSeguridadFooter } from '../../../core/ui/icons.js';

export function createVendedorPresenter({
  render,
  getFirebase,
  repo,
  onBackHome,
  onOpenProfile,
  onIrPlanPremium,
  onPerfilVendedorCompleto,
  onIrAlCatalogo,
  onOpenServicios,
  isProfileComplete,
  onMisNavPerfil,
  onBeforeOpenPublicarDesdeMis,
  onPubMisPushHistorial,
  onPubMisCerrarHistorial,
}) {
  function backToHome() {
    return onBackHome?.();
  }

  function irAlCatalogoDesdeVendedor() {
    onIrAlCatalogo?.();
  }

  const misPublicacionesView = createMisPublicacionesView({
    render,
    getFirebase,
    repo,
    backToHome,
    onOpenProfile,
    onMisNavPerfil,
    onIrAlCatalogo: irAlCatalogoDesdeVendedor,
    onOpenServicios,
    showPublicarView: async () => {
      onBeforeOpenPublicarDesdeMis?.();
      await publicarView();
    },
  });

  const publicarView = createPublicarView({
    render,
    getFirebase,
    repo,
    backToHome,
    onOpenProfile,
    onIrPlanPremium,
    onIrAlCatalogo: irAlCatalogoDesdeVendedor,
    onOpenServicios,
    showMisPublicaciones: misPublicacionesView,
    beforeOpenMisDesdePublicar: onPubMisPushHistorial,
    afterCloseMisDesdePublicar: onPubMisCerrarHistorial,
  });

  /**
   * Formulario único de onboarding: nombre + teléfono + calle + nro_casa.
   * Sin OCR, sin DNI, sin paso 2.
   */
  function datosVendedorView(profile) {
    const p = profile || {};
    const inputBase =
      'w-full rounded-xl border-0 px-3 py-2.5 text-slate-900 shadow-sm ring-1 ring-slate-200/80 focus:outline-none focus:ring-2 focus:ring-brand-primary/30 bg-slate-50';
    render(`
      <main class="min-h-screen max-w-lg mx-auto bg-brand-surface mlv-bg-surface px-4 pb-8 pt-6">
        <header class="flex items-center justify-between gap-3 mb-6">
          <h1 class="mlv-page-title font-heading text-2xl font-bold tracking-tight text-brand-primary">Completá tu perfil</h1>
          <button type="button" id="btn-back-home" class="mlv-text-brand shrink-0 text-xs font-medium text-brand-primary hover:opacity-80">Volver</button>
        </header>
        <p class="mb-6 text-sm leading-relaxed text-slate-600">
          Necesitamos tu nombre, teléfono y dirección del barrio La Victoria.
          Si te denuncian por no ser del barrio, podrás validar tu ubicación con GPS.
        </p>
        <form id="form-datos-vendedor" class="space-y-6">
          <section>
            <div class="flex items-center gap-3 mb-3">
              <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-primary text-sm font-bold text-white">1</span>
              <h2 class="font-heading text-lg font-bold text-slate-800">Nombre</h2>
            </div>
            <label class="block text-sm font-semibold text-slate-700 mb-1.5">Nombre y apellido</label>
            <input name="nombre" type="text" required minlength="2" maxlength="80" autocomplete="name" class="${inputBase}" value="${esc(p.nombre || '')}" placeholder="Ej.: Kevin Maggio" />
          </section>
          <section>
            <div class="flex items-center gap-3 mb-3">
              <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-200 text-sm font-bold text-slate-600">2</span>
              <h2 class="font-heading text-lg font-bold text-slate-800">Dirección en La Victoria</h2>
            </div>
            <div class="space-y-3">
              <div>
                <label class="block text-sm font-semibold text-slate-700 mb-1.5">Nombre de la calle</label>
                <input name="calle" type="text" required class="${inputBase}" value="${esc(p.calle || '')}" placeholder="Ej.: Av. Rivadavia" autocomplete="address-line1" />
              </div>
              <div>
                <label class="block text-sm font-semibold text-slate-700 mb-1.5">Número de casa</label>
                <input name="nro_casa" type="text" required class="${inputBase}" value="${esc(p.nro_casa || '')}" placeholder="Ej.: 1234" autocomplete="address-line2" />
              </div>
            </div>
          </section>
          <section>
            <div class="flex items-center gap-3 mb-3">
              <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-200 text-sm font-bold text-slate-600">3</span>
              <h2 class="font-heading text-lg font-bold text-slate-800">Contacto</h2>
            </div>
            <label class="block text-sm font-semibold text-slate-700 mb-2">WhatsApp / Teléfono</label>
            <div class="flex rounded-2xl overflow-hidden bg-white shadow-sm ring-1 ring-slate-200/80 focus-within:ring-2 focus-within:ring-brand-primary/30">
              <span class="flex items-center px-3 py-3 text-slate-600 font-medium bg-slate-100/90 border-r border-slate-200">+54</span>
              <input name="telefono" type="tel" required class="min-w-0 flex-1 border-0 bg-white px-3 py-3 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-0" placeholder="11 2345 6789" value="${esc(p.telefono || '')}" autocomplete="tel" />
            </div>
            <p class="text-xs text-slate-500 mt-2">Los compradores verán este número al publicar.</p>
          </section>
          <p id="form-msg" class="text-sm text-red-700 min-h-[1.25rem] rounded-xl px-3 py-2 bg-red-50 border border-red-100 empty:hidden"></p>
          <button type="submit" id="btn-guardar-datos" class="btn-async mlv-btn-primary flex w-full items-center justify-center gap-2 rounded-full bg-brand-primary py-3.5 px-6 font-semibold text-white shadow-md transition hover:brightness-95 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2">
            Guardar y entrar
            ${iconArrowRight()}
          </button>
          ${bloqueSeguridadFooter()}
        </form>
      </main>
    `);

    document.getElementById('btn-back-home').onclick = () => backToHome();

    document.getElementById('form-datos-vendedor').onsubmit = async (e) => {
      e.preventDefault();
      const msg = document.getElementById('form-msg');
      msg.textContent = '';
      const uid = getFirebase().auth.currentUser?.uid;
      if (!uid) {
        msg.textContent = 'Sesión expirada. Volvé a entrar.';
        return;
      }
      const fd = new FormData(e.target);
      const nombre = String(fd.get('nombre') || '').trim();
      const telefono = String(fd.get('telefono') || '').trim();
      const calle = String(fd.get('calle') || '').trim();
      const nro_casa = String(fd.get('nro_casa') || '').trim();
      if (nombre.length < 2) {
        msg.textContent = 'Ingresá tu nombre y apellido.';
        return;
      }
      if (!telefono) {
        msg.textContent = 'Ingresá un número de contacto.';
        return;
      }
      if (!calle) {
        msg.textContent = 'Ingresá el nombre de tu calle.';
        return;
      }
      if (!nro_casa) {
        msg.textContent = 'Ingresá el número de casa.';
        return;
      }
      const direccion = `${calle} ${nro_casa}`;
      const btn = document.getElementById('btn-guardar-datos');
      await withBusyButton(btn, async () => {
        try {
          const payload = {
            nombre,
            telefono,
            calle,
            nro_casa,
            direccion,
          };
          payload.perfilCompleto = isProfileComplete({ ...p, ...payload, habilitadoParaMarket: true });
          await repo.guardarDatosVendedor(uid, payload);
          if (!payload.perfilCompleto) {
            msg.textContent = 'No se pudo marcar el perfil como completo.';
            return;
          }
          onPerfilVendedorCompleto?.();
        } catch (err) {
          console.error(err);
          msg.textContent = err?.message || 'Error al guardar.';
        }
      });
    };
  }

  async function cambiarTelefonoContactoView(profileSeed = null, { onBack } = {}) {
    const uid = getFirebase().auth.currentUser?.uid;
    if (!uid) return backToHome();
    const volver = typeof onBack === 'function' ? onBack : onOpenProfile;
    let p = profileSeed;
    if (!p) p = await repo.loadUserProfile(uid);
    const telefonoActual = String(p?.telefono || '').trim();
    render(`
      <main class="min-h-screen max-w-lg mx-auto bg-brand-surface mlv-bg-surface px-4 pb-8 pt-6">
        <header class="flex items-center justify-between gap-3 mb-6">
          <h1 class="mlv-page-title font-heading text-2xl font-bold tracking-tight text-brand-primary">Cambiar número de contacto</h1>
          <button type="button" id="tel-back" class="mlv-text-brand text-xs font-medium text-brand-primary hover:opacity-80">Volver</button>
        </header>
        <form id="form-cambiar-telefono" class="mt-5 space-y-4">
          <label class="block text-sm font-semibold text-slate-700">WhatsApp / Teléfono</label>
          <div class="flex rounded-2xl overflow-hidden bg-white shadow-sm ring-1 ring-slate-200/80 focus-within:ring-2 focus-within:ring-brand-primary/30">
            <span class="flex items-center px-3 py-3 text-slate-600 font-medium bg-slate-100/90 border-r border-slate-200">+54</span>
            <input name="telefono" type="tel" required class="min-w-0 flex-1 border-0 bg-white px-3 py-3 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-0" placeholder="11 2345 6789" value="${esc(telefonoActual)}" autocomplete="tel" />
          </div>
          <p id="tel-msg" class="min-h-[1.25rem] text-sm text-red-600"></p>
          <button type="submit" id="btn-save-tel" class="btn-async mlv-btn-primary w-full rounded-full bg-brand-primary py-3.5 px-6 font-semibold text-white shadow-md transition hover:brightness-95">Guardar contacto</button>
        </form>
      </main>
    `);
    document.getElementById('tel-back').onclick = () => volver?.();
    document.getElementById('form-cambiar-telefono').onsubmit = async (e) => {
      e.preventDefault();
      const msg = document.getElementById('tel-msg');
      const btn = document.getElementById('btn-save-tel');
      msg.textContent = '';
      const fd = new FormData(e.target);
      const telefono = String(fd.get('telefono') || '').trim();
      if (!telefono) {
        msg.textContent = 'Ingresá un número de contacto.';
        return;
      }
      await withBusyButton(btn, async () => {
        try {
          const latest = await repo.loadUserProfile(uid);
          const payload = {
            telefono,
            perfilCompleto: isProfileComplete({ ...latest, telefono }),
          };
          await repo.guardarDatosVendedor(uid, payload);
          await repo.loadUserProfile(uid, { forceServer: true });
          msg.classList.remove('text-red-600');
          msg.classList.add('text-emerald-700');
          msg.textContent = 'Contacto actualizado.';
          setTimeout(() => volver?.(), 500);
        } catch (err) {
          console.error(err);
          msg.classList.remove('text-emerald-700');
          msg.classList.add('text-red-600');
          msg.textContent = err?.message || 'No se pudo guardar.';
        }
      });
    };
  }

  async function showMainFlow() {
    onOpenProfile?.();
  }

  return {
    datosVendedorView,
    showCambiarTelefonoContacto: cambiarTelefonoContactoView,
    showMainFlow,
    showPublicarForm: publicarView,
    showMisPublicaciones: misPublicacionesView,
    isProfileComplete,
  };
}
